import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
interface ClientModalProps {
    show: boolean;
    onHide: () => void;
    onSubmit: (data: any) => void;
    mode: 'create' | 'update';
    initialData?: Partial<ClientFormData>;
}

interface ClientFormData {
    name: string;
    email: string;
    mobile?: string;
    password?: string;
}

const ClientModal: React.FC<ClientModalProps> = ({ show, onHide, onSubmit, mode, initialData }) => {
    const [formData, setFormData] = useState<ClientFormData>({
        name: '',
        email: '',
        mobile: '',
        password: '',
    });

    const [errors, setErrors] = useState<{ [key: string]: string }>({});

    useEffect(() => {
        if (initialData && mode === 'update') {
            setFormData(prev => ({
                ...prev,
                ...initialData,
                password: ''
            }));
        }
    }, [initialData, mode]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = () => {
        onSubmit(formData);
    };

    return (
        <Modal size="lg" show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>{mode === 'create' ? 'Create Client' : 'Update Client'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3" controlId="formClientName">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter client name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            isInvalid={!!errors.name}
                        />
                        <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formClientEmail">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            type="email"
                            placeholder="Enter email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            isInvalid={!!errors.email}
                        />
                        <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formClientMobile">
                        <Form.Label>Mobile</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="10 digit mobile number"
                            name="mobile"
                            value={formData.mobile || ''}
                            onChange={handleChange}
                            isInvalid={!!errors.mobile}
                        />
                        <Form.Control.Feedback type="invalid">{errors.mobile}</Form.Control.Feedback>
                    </Form.Group>

                    {mode === 'create' && (
                        <Form.Group className="mb-3" controlId="formClientPassword">
                            <Form.Label>Password</Form.Label>
                            <Form.Control
                                type="password"
                                placeholder="Enter password"
                                name="password"
                                value={formData.password || ''}
                                onChange={handleChange}
                                isInvalid={!!errors.password}
                            />
                            <Form.Control.Feedback type="invalid">{errors.password}</Form.Control.Feedback>
                        </Form.Group>
                    )}

                    <Button variant="primary" onClick={handleSubmit}>
                        {mode === 'create' ? 'Create Client' : 'Update Client'}
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default ClientModal;
